import { Box, Button, Popover } from "@mui/material";
import { useState } from "react";
import { Color, ColorResult, RGBColor, SketchPicker } from "react-color";
interface ColorPickerProps {
  children: any;
  onSave: (color: any) => void;
}
const ColorPicker = ({ children, onSave }: ColorPickerProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);
  const [color, setColor] = useState<Color>();

  const handleClick = (event: React.MouseEvent<HTMLDivElement>): void => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (): void => {
    setAnchorEl(null);
  };

  const handleChange = (color: ColorResult): void => {
    setColor(color.hex);
  };

  const open = Boolean(anchorEl);
  const id = open ? "color-picker-popover" : undefined;
  return (
    <>
      <Box
        sx={{
          color: "#fff",
        }}
        aria-describedby={id}
        onClick={handleClick}
      >
        {children}
      </Box>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <Box sx={{ p: "8px" }}>
          <SketchPicker color={color} onChange={handleChange} />{" "}
          <Button
            variant="contained"
            color="primary"
            sx={{
              textTransform: "unset",
              marginTop: "8px",
            }}
            onClick={() => {
              onSave(color);
              setAnchorEl(null);
            }}
          >
            Save
          </Button>
        </Box>
      </Popover>
    </>
  );
};

export default ColorPicker;
